import { Pipe, PipeTransform } from '@angular/core';
import { format as formatDate, isValid, parseISO } from 'date-fns';
import { isDate, isNil, isNumber, isString } from 'lodash';

import { dateFormatDefault } from '../constants/date-formats';

type FormatDatePipeValue = Date | number | null | string | undefined;

@Pipe({
  name: 'formatDate',
  pure: true,
})
export class FormatDatePipe implements PipeTransform {
  transform(value: FormatDatePipeValue, format: string | undefined = dateFormatDefault): string {
    const dateValue = this.convertValueToDate(value);

    if (isNil(dateValue) || !isValid(dateValue)) {
      return '';
    }

    const formatValue = this.getFormatValue(format);

    let formattedDate: string;

    try {
      formattedDate = formatDate(dateValue, formatValue);
    } catch {
      formattedDate = '';
    }

    return formattedDate;
  }

  private convertValueToDate(value: FormatDatePipeValue): Date | undefined {
    if (isNil(value)) {
      return undefined;
    } else if (isString(value)) {
      const parsed = parseISO(value.trim());

      return isValid(parsed) ? parsed : new Date(value);
    } else if (isDate(value)) {
      return value;
    } else if (isNumber(value)) {
      return new Date(value);
    }

    return undefined;
  }

  private getFormatValue(format: string | undefined) {
    return format || dateFormatDefault;
  }
}
